import BaseApi from './BaseApi';

class PatientTreatmentHistoryApi extends BaseApi {
  public getTreatmentEpisodes(patientId: number | string) {
    return this.get(`/${patientId}/treatment-episodes`);
  }

  /**
   * No.198 — save or clear the staff memo on one treatment history log.
   * An empty `content` clears it. The answer is always `{ memo: … }`, with
   * `memo` null once the memo is gone.
   */
  public updateTreatmentEpisodeMemo(
    patientId: number | string,
    episodeId: number | string,
    content: string,
  ) {
    return this.put(`/${patientId}/treatment-episodes/${episodeId}/memo`, { content });
  }

  protected getSpecificApiPrefix(): string {
    return 'managers/patients';
  }
}

export default PatientTreatmentHistoryApi;
